var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("EventListingsController", [
    "$scope", "$rootScope", "$location", "eventsService", "digitalEventFormatterService",
    function ($scope, $rootScope, $location, eventsService, digitalEventFormatterService) {
        $scope.eventBannerimgPath = window.__env.digitalEventImgBaseUrl;
        $scope.getDigitalEvents = function () {
            eventsService.getDigitalEvents().then(
                function (response) {
                    if (response && response.data) {
                        $scope.events = response.data.map(function (event) {
                            return digitalEventFormatterService.enrichEvent(event);
                        });
                    }
                }
            );
        }
        $scope.getDigitalEvents();
    },
]);
